import React from "react";
import Hero from "../components/hero/Hero";
import OrderBanner from "../components/orderbanner/OrderBanner";
import Popular from "../components/popular/Popular";
import Offers from "../components/offers/Offers";
import NewCollections from "../components/newcollections/NewCollections";
import NewsLetter from "../components/newsletter/NewsLetter";
import NJSweets from "../components/njsweets/NJSweets";
import ScrollToTop from "../components/util/ScrollToTop";
import Seo from "../components/seo/Seo";

const Shop = () => {
    return (
        <div>
            <Seo path="/" />
            <ScrollToTop />
            <OrderBanner />
            <Popular />
            {/* <NJSweets /> */}
            {/* <Hero/> */}
            {/* <Offers/> */}
            {/* <NewCollections /> */}
            {/* <NewsLetter/> */}

        </div>
    )
}

export default Shop;